var version = {
    "name":      "dativery",
    "buildDateCode": "20251201-140400",
    "buildDate": "Mon Dec 01 2025 14:04:00 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251201-140400",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;